export default "__VITE_ASSET__e1f65346__"